import { useNavigate } from 'react-router-dom';

const EditItemBtn = ({ itemId }) => {
  const navigate = useNavigate();

  const handleEdit = () => {
    navigate(`/cats/merchant/assets/edit/${itemId}`);
  };

  return (
    <button onClick={handleEdit}>
      Edit Item
    </button>
  );
};

export default EditItemBtn;
